import React from 'react';
import swal from 'sweetalert';
import shortid from 'shortid';
import { spmfcloudFunctionUrl } from '../../../actions/salesforces';
import { encryptQuery } from '../../../utils/common';
import { fetchQueryData } from '../../../utils/sf-request';

export function getBeneficiaryDetail(id, siteToken, publicKey) {
    const query = `Select Id, Name, Full_Name__c, ID_Type__c, ID_Number__c, Relationship_to_Applicant__c,
        Relationship_to_Applicant_Other__c, Other_Relationship__c, Relationship_to_Beneficiary__c, Relationship_to_Beneficiary_Other__c,
        Application_Date__c, Gender__c, Age_at_Application__c, Approve_Exception__c,
        Current_School__r.Name, Referred_From__r.Name, Current_School__r.Partner_SubType__c, Race__c, Other_Race__c, Nationality__c,
        Other_Nationality__c,Marital_Status__c, Other_Marital_Status__c, Application__c, Applying_to__r.Id,
        Applying_to__r.Name, Application_Type__c, Referred_From__c, Referred_Date__c, Application_Status__c,
        Current_Level__c, Referring_Reason__c, Stream__c, Email_Address__c, Religion__c, Other_Religion__c, Incomplete_Document__c,
        Date_of_Birth__c, No_of_Receipt__c, No_of_Receipt_Max__c, Office_Number__c,No_of_Receipts_Approved__c, Payout_Start__c, Payout_End__c,
        RecordType.Name, Main_Applicant__c, Employment_Status__c, Occupation__c, Company__c, Monthly_Gross_Income__c, Approver_Name__r.Name, Send_Approve_Request__c,
        Extension_In_no_of_months__c, Remarks__c,
        Contact_Number__c, Home_Phone__c, Mobile_Phone__c From Person__c Where Id='${id}'`;
    return fetchQueryData(query, siteToken, publicKey);
}

export function getContactDetail(id, siteToken, publicKey) {
    const query = `Select Id, Name, Active__c
        From Contact Where Updated_by_Application_Person__r.Id='${id}'`;
    return fetchQueryData(query, siteToken, publicKey);
}

export function getBeneficiaryReceiptList(beneficiaryId, siteToken, publicKey) {
    const query = `SELECT Id, Status__c, Name, Issued_By__c, Scheduled_Payout_Date__c, Date_Received__c, Approved_Amount__c, Generated_From__c
        FROM Receipt__c WHERE Generated_From__c = '${beneficiaryId}' AND (Status__c = 'Received by Beneficiary' OR Status__c = 'Disbursed') ORDER BY Status__c, Scheduled_Payout_Date__c`;
    return fetchQueryData(query, siteToken, publicKey);
}

/**
 * @param {*} data: Object - What field that need to be updated
 * @param {*} siteToken: String - SPMF website application token
 * return Fetch <Promise>
 */
export function changeBeneficiaryStatus(data, siteToken) {
    return fetch(`${spmfcloudFunctionUrl}/update-bene-status`, {
        mode: 'cors',
        body: JSON.stringify({
            data,
            applicationId: this.state.beneDetail.Application__c,
        }),
        cache: 'no-cache',
        method: 'POST',
        headers: {
            'hash-token': siteToken,
            'Content-Type': 'application/json',
        },
    }).then(response => response.json());
}

/**
 * This method need to be binded with main component
 * return Fetch Promise JSON
 */
export function getBeneficiaryList() {
    const query = this.props.user.loggedInUser.Partner_Authority__c !== null ?
        `SELECT Beneficiary__r.Name, Generated_From__r.Id, Generated_From__r.Contact_Name__r.Active__c, Generated_From__r.Contact_Name__r.Name, Generated_From__r.Race__c, Generated_From__r.Application__r.Applicant_Name__c, Generated_From__r.Contact_Name__r.Last_Payment_Date__c, Generated_From__r.Application_Status__c, Generated_From__r.Full_Name__c, Generated_From__r.Gender__c, Generated_From__r.ID_type__c, Generated_From__r.Nationality__c, Generated_From__r.ID_Number__c, Generated_From__r.Applying_To__c FROM Receipt__c WHERE Generated_From__r.Contact_Name__c <> null AND Generated_From__r.Applying_to__c = '${this.props.user.loggedInUser.AccountId}' and Generated_From__r.RecordType.Name = 'Beneficiary'` :

        `SELECT Beneficiary__r.Name, Generated_From__r.Id, Generated_From__r.Contact_Name__r.Active__c, Generated_From__r.Contact_Name__r.Name, Generated_From__r.Race__c, Generated_From__r.Application__r.Applicant_Name__c, Generated_From__r.Contact_Name__r.Last_Payment_Date__c, Generated_From__r.Application_Status__c, Generated_From__r.Full_Name__c, Generated_From__r.Gender__c, Generated_From__r.ID_type__c, Generated_From__r.Nationality__c, Generated_From__r.ID_Number__c, Generated_From__r.Applying_To__c FROM Receipt__c WHERE Generated_From__r.Contact_Name__c <> null AND Generated_From__r.Application__r.Related_Account__c = '${this.props.user.loggedInUser.AccountId}' and Generated_From__r.RecordType.Name = 'Beneficiary'`;
    return fetchQueryData(query, this.props.user.siteToken.hash, this.props.user.key)
        .then((json) => {
            // Filter based by Generated_From__r.Id
            const personIdList = json.records.map(receipt => receipt.Generated_From__r.Id);
            const uniqueIdList = [...new Set(personIdList)];
            const result = Object.assign({}, json);
            result.records = uniqueIdList.map(id => json.records.filter(receipt => receipt.Generated_From__r.Id === id)[0]);

            // Change boolean values to string ones in Generated_From__r.Contact_Name__r.Active__c
            result.records = result.records.map((rec) => {
                rec.Generated_From__r.Contact_Name__r.Active__c = `${rec.Generated_From__r.Contact_Name__r.Active__c}`;
                return rec;
            });

            return result;
        });
}

export const describeBeneficiaryObject = () => (
    async (dispatch, getState) => {
        // if (getState().objectInfo.Person__c.length > 0) return;
        const result = await fetch(`${spmfcloudFunctionUrl}/sobject/Person__c/describe`, {
            mode: 'cors',
            cache: 'no-cache',
            method: 'GET',
            headers: {
                'hash-token': getState().user.siteToken.hash,
                'Content-Type': 'application/json',
            },
        }).then(response => response.json());
        dispatch({
            type: 'PERSON_DESCRIBE',
            payload: result.result.fields || {},
        });
        const result2 = await fetch(`${spmfcloudFunctionUrl}/sobject/Fund_Request__c/describe`, {
            mode: 'cors',
            cache: 'no-cache',
            method: 'GET',
            headers: {
                'hash-token': getState().user.siteToken.hash,
                'Content-Type': 'application/json',
            },
        }).then(response => response.json());

        dispatch({
            type: 'FR_DESCRIBE',
            payload: result2.result.fields || {},
        });

        const result3 = await fetch(`${spmfcloudFunctionUrl}/sobject/Application__c/describe`, {
            mode: 'cors',
            cache: 'no-cache',
            method: 'GET',
            headers: {
                'hash-token': getState().user.siteToken.hash,
                'Content-Type': 'application/json',
            },
        }).then(response => response.json());
        dispatch({
            type: 'APPLICATION_DESCRIBE',
            payload: result3.result.fields || {},
        });
    }
);

/**
 * To list all the picklist member, this function need to be binded with main component
 * @param {*} objectName : What is the ObjectName that we want to retrieve
 * @param {*} fieldName
 */
export function getPicklist(objectName, fieldName) {
    if (this === undefined) return [];
    let pickList = [];
    for (let i = 0; i < this.props.objectInfo[objectName].length; i++) {
        if (this.props.objectInfo[objectName][i].name === fieldName) {
            pickList = this.props.objectInfo[objectName][i].picklistValues;
        }
    }
    if (objectName === 'Person__c' && fieldName === 'Relationship_to_Beneficiary__c') {
        // console.info(this.props.objectInfo.Person__c.map(obj => obj.name).sort())
        // console.log(99, pickList)
    }
    return pickList.map(item => (
        item.active ? <option key={shortid.generate()} value={item.value}>{item.label}</option> : null
    ));
}
/**
 * Save function to salesforce from beneficiary list, this function need to be binded with main component
 */

export async function setApprover(approver, siteToken){
    return fetch(`${spmfcloudFunctionUrl}/sobject/Person__c`, {
        mode: 'cors',
        method: 'PATCH',
        body: JSON.stringify(approver),
        cache: 'no-cache',
        headers: {
            'hash-token': siteToken,
            'Content-Type': 'application/json',
        },
    })
}

export async function sendNotifApprover(data, siteToken){
    return fetch(`${spmfcloudFunctionUrl}/sobject/Person__c`, {
        mode: 'cors',
        method: 'PATCH',
        body: JSON.stringify(data),
        cache: 'no-cache',
        headers: {
            'hash-token': siteToken,
            'Content-Type': 'application/json',
        },
    })
}

export async function save() {
    const { beneDetail, applicationDetail } = this.state;
    const dataToSave = {
        Id: beneDetail.Id,
        Full_Name__c: beneDetail.Full_Name__c,
        ID_Type__c: beneDetail.ID_Type__c,
        ID_Number__c: beneDetail.ID_Number__c,
        Gender__c: beneDetail.Gender__c,
        Nationality__c: beneDetail.Nationality__c,
        Other_Nationality__c: beneDetail.Other_Nationality__c,
        Relationship_to_Applicant__c: beneDetail.Relationship_to_Applicant__c,
        Relationship_to_Applicant_Other__c: beneDetail.Relationship_to_Applicant_Other__c,
        Relationship_to_Beneficiary__c: beneDetail.Relationship_to_Beneficiary__c,
        Relationship_to_Beneficiary_Other__c: beneDetail.Relationship_to_Beneficiary_Other__c,
        Race__c: beneDetail.Race__c,
        Other_Race__c: beneDetail.Other_Race__c,
        Marital_Status__c: beneDetail.Marital_Status__c,
        Other_Marital_Status__c: beneDetail.Other_Marital_Status__c,
        Email_Address__c: beneDetail.Email_Address__c,
        Incomplete_Document__c: beneDetail.Incomplete_Document__c,
        Contact_Number__c: beneDetail.Contact_Number__c,
        Monthly_Gross_Income__c: beneDetail.Monthly_Gross_Income__c ? beneDetail.Monthly_Gross_Income__c : '',
        Employment_Status__c: beneDetail.Employment_Status__c ? beneDetail.Employment_Status__c : '',
        Occupation__c: beneDetail.Occupation__c ? beneDetail.Occupation__c : '',
        Company__c: beneDetail.Company__c ? beneDetail.Company__c : '',
        Extension_In_no_of_months__c: beneDetail.Extension_In_no_of_months__c ? beneDetail.Extension_In_no_of_months__c : '',
        Approve_Exception__c: beneDetail.Extension_In_no_of_months__c ? true : false,
        Referring_Reason__c: beneDetail.Referring_Reason__c,
        Referred_Date__c: beneDetail.Referred_Date__c,
        Remarks__c: beneDetail.Remarks__c,
        Current_School__c: beneDetail.Current_School__r && beneDetail.Current_School__r.Id,
        Referred_From__c:  beneDetail.Referred_From__r && beneDetail.Referred_From__r.Id,
        Applying_to__c: beneDetail.Applying_to__r && beneDetail.Applying_to__r.Id,
        Application_Type__c: beneDetail.Application_Type__c,
        Application_Status__c: beneDetail.Application_Status__c,
        Current_Level__c: beneDetail.Current_Level__c,
        Stream__c: beneDetail.Stream__c,
        Date_of_Birth__c: beneDetail.Date_of_Birth__c,
    };
    const appDataToSave = {
        Id: beneDetail.Application__c,
        Other_Source_of_Income__c: applicationDetail.Other_Source_of_Income__c ? applicationDetail.Other_Source_of_Income__c : '',
        Other_Source_of_Income_Amount__c: applicationDetail.Other_Source_of_Income_Amount__c ? applicationDetail.Other_Source_of_Income_Amount__c : '',
    };
    this.setState({ loading: true });

    try {
        const result = await fetch(`${spmfcloudFunctionUrl}/sobject/Person__c`, {
            mode: 'cors',
            method: 'PATCH',
            body: JSON.stringify(dataToSave),
            cache: 'no-cache',
            headers: {
                'hash-token': this.props.user.siteToken.hash,
                'Content-Type': 'application/json',
            },
        }).then(response => response.json());
        if (result.status !== 200) throw (new Error(result.message));

        if (beneDetail.Main_Applicant__c) {
            const result2 = await fetch(`${spmfcloudFunctionUrl}/sobject/Application__c`, {
                mode: 'cors',
                method: 'PATCH',
                body: JSON.stringify(appDataToSave),
                cache: 'no-cache',
                headers: {
                    'hash-token': this.props.user.siteToken.hash,
                    'Content-Type': 'application/json',
                },
            }).then(response => response.json());
            if (result2.status !== 200) throw (new Error(result2.message));
        }

        swal({
            text: result.message,
            title: 'Success updating beneficiary',
        });
        this.setState({ loading: false, editMode: false });
    } catch (error) {
        swal({
            text: error.toString(),
            title: 'An error occured',
            dangerMode: true,
        });
        this.setState({ loading: false });
    }
}

export function getApplicationDetail(id, siteToken, publicKey) {
    const query = `Select Application_Status__c, Other_Source_of_Income__c, Other_Source_of_Income_Amount__c
        From Application__c Where Id='${id}'`;
    return fetchQueryData(query, siteToken, publicKey);
}

export function getBeneAttachment(beneId, siteToken, publicKey) {
    const query = `Select Id, Name, Body, BodyLength, ContentType, Description From Attachment
        Where ParentId ='${beneId}'`;
    return fetchQueryData(query, siteToken, publicKey).catch(err => console.log(err));
}

export default null;



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Beneficiary/actions.js
// module id = 98
// module chunks = 0